import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Grid,
    Paper,
    Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch } from 'react-redux';
import { toggleModal } from "../../reducers/modalReducer"

// images to show 
import investor1 from '../../../images/pricing-page/investor/pricing-investor1.png'
import investor2 from '../../../images/pricing-page/investor/pricing-investor2.png'
import investor3 from '../../../images/pricing-page/investor/pricing-investor3.png'
import investor4 from '../../../images/pricing-page/investor/pricing-investor4.png'

import advisor1 from '../../../images/pricing-page/advisor/pro1.png'
import advisor2 from '../../../images/pricing-page/advisor/pro2.png'
import advisor3 from '../../../images/pricing-page/advisor/pro3.png'
import advisor4 from '../../../images/pricing-page/advisor/pro4.png'
import advisor5 from '../../../images/pricing-page/advisor/proPlus1.png'
import advisor6 from '../../../images/pricing-page/advisor/proPlus2.png'
import advisor7 from '../../../images/pricing-page/advisor/proPlus3.png'
import advisor8 from '../../../images/pricing-page/advisor/proPlus4.png'

import company1 from '../../../images/pricing-page/company/company1.png'
import { PRICING_PLANS } from '../../constants/Plans';


const renderTitle = (titleText, handleModal, mainTitle) => {
    if (titleText.includes('|')) {
        const [beforePipe, afterPipe] = titleText.split('|');
        return (
            <>
                {beforePipe}
                <img
                    src={require('../../../images/helpCircle.svg')}
                    alt="helpCircle"
                    width={16}
                    height={16}
                    className='ml0-5rem'
                />
            </>
        );
    } else if (titleText.includes('&')) {
        const [beforePipe, afterPipe] = titleText.split('&');
        return (
            <>
                {beforePipe}
                <img
                    src={require('../../../images/infoIcon.svg')}
                    onClick={() => handleModal(mainTitle)}
                    alt="helpCircle"
                    width={16}
                    height={16}
                    className='ml0-5rem cp'
                />
            </>
        );
    }
    return titleText;
};

const FeatureRow = ({ label, values, plans, containterClass, handleModal, activeTab }) => {
    const images = {
        Investors: {
            1: investor1,
            2: investor2,
            3: investor3,
            4: investor4,
        },
        Advisors: {
            1: advisor1,
            2: advisor2,
            3: advisor3,
            4: advisor4,
            5: advisor5,
            6: advisor6,
            7: advisor7,
            8: advisor8,
        },
        Companies: {
            1: company1
        }
    }
    return (
        <Grid
            container
            spacing={2}
            alignItems="center"
            className={containterClass}
            sx={{
                paddingTop: '12px',
                paddingBottom: '12px',
                borderBottom: '1px solid #8282823a',
                height: '60px',
                margin: '0px 0px 0px -8px'
            }}>
            <Grid xs={activeTab === "Advisors" ? 5 : activeTab === "Investors" ? 6 : 4} sx={{
                paddingTop: '0px !important', paddingLeft: '16px',
                ...(activeTab === "Advisors" && {
                    maxWidth: '42% !important',
                    flexBasis: '42% !important',
                })
            }}>
                <Typography
                    variant="body2"
                    className='tal fw400 df aic'
                    sx={{
                        fontSize: '13px !important',
                    }}
                >
                    {renderTitle(label, handleModal)}
                    {
                        label.includes('Sync') ? <>
                            <img className='ml1rem' src={require('../../../images/dataRepo/dataroom.svg')} alt="dataRooms" />
                        </> : (label.includes('Unaudited Certification') || ['Chargeable quarterly reviews', 'Quarterly portfolio Reviews'].includes(label)) ? <div className='df aic jcc'>
                            <img className='ml0-5rem' src={require('../../../images/certifications/certificationPricing1.svg')} alt="certificationPricing" />
                            <img className='ml0-5rem' src={require('../../../images/certifications/certificationPricing2.svg')} alt="certificationPricing2" />
                            <img className='ml0-5rem' src={require('../../../images/certifications/certificationPricing3.svg')} alt="certificationPricing3" />
                        </div> : null
                    }
                </Typography>
            </Grid>
            {plans.map((plan) => {
                return (
                    <Grid xs={activeTab === "Advisors" ? 2 : activeTab === "Investors" ? 3 : 2} key={plan} sx={{
                        paddingTop: "0px !important",
                        ...(activeTab === "Advisors" && {
                            maxWidth: '19% !important',
                            flexBasis: '19% !important',
                        })
                    }}>
                        <Typography className='fw400 fs11px pr' sx={{ fontSize: '13px !important' }} align="center">
                            {(values[plan] && typeof values[plan] === "string" && values[plan].includes("image")) ? <img className='pa w90' style={{ left: '5%', top: '-30px' }} src={images[activeTab][Number(values[plan].match(/\d+/)[0])]} alt="info" /> : typeof values[plan] === 'boolean' ? values[plan] ? <img src={require('../../../images/check.svg')} alt='allowedIcon' /> : plan.toLowerCase().includes('pro') ? '' : '-' : values[plan] || '-'}
                        </Typography>
                    </Grid>
                )
            })}
        </Grid>
    );
};

const isPlanRow = (value, plans) =>
    value && typeof value === 'object' &&
    !Array.isArray(value) &&
    plans.every((plan) => plan in value);

let mainTitle = null;
let activeTab = "Companies"

const FeatureAccordion = ({ title, items, plans, nestingLevel = 0, titleInfo, onModalOpen, tab }) => {
    if (tab) {
        activeTab = tab
    }
    if (titleInfo) {
        mainTitle = titleInfo;
    }
    const dispatch = useDispatch();

    const handleModal = (mainTitle1) => {
        dispatch(toggleModal({ open: 'pricingPage' }));
        if (onModalOpen) {
            onModalOpen(mainTitle1);
        }
    };

    const hasNestedAccordion = Object.values(items).some(value =>
        typeof value === 'object' &&
        !Array.isArray(value) &&
        !plans.every(plan => plan in value)
    );

    const getBackgroundColor = () => {
        if (nestingLevel === 0) {
            if ("We Get You Organised" === title) {
                return '#FFDB4299'
            } else if (['Your Growth Journey &', 'Accelerate Your Client’s Growth Journey &', 'Post-Investment  Growth - Portfolio Companies &'].includes(title.trim())) {
                return '#FF39A94D'
            } else if (['Your Exit Journey &', 'Accelerate Your Client’s Exit Journey &', 'Portfolio Companies Permanently Exit Ready &'].includes(title.trim())) {
                return '#FF9D144D'
            } else if (['Your Investment Journey &', 'FREE Triaging of Applicant Companies &', 'Boost Margins - New Revenue Streams - New Clients'].includes(title.trim())) {
                return '#45D6F64D'
            } else if (['Accelerate Your Client’s Investment Journey &'].includes(mainTitle.trim())) {
                return '#00EEEF4D'
            } else {
                return '#B2BDFF'
            }
        };
        if (nestingLevel === 1) {
            if (['Your Growth Journey &', 'Accelerate Your Client’s Growth Journey &', 'Post-Investment  Growth - Portfolio Companies &'].includes(mainTitle.trim())) {
                return '#FFA4D74D'
            } else if (['Accelerate Your Client’s Investment Journey &'].includes(mainTitle.trim())) {
                return '#00EEEF4D'
            } else if (['Your Exit Journey &', 'Accelerate Your Client’s Exit Journey &', 'Portfolio Companies Permanently Exit Ready &'].includes(mainTitle.trim())) {
                return '#FFCE894D'
            }
            else {
                return '#9DEDFF4D'
            }
        };
        return '#e8ebff4D';
    };

    // Special handling for Support section
    if (title === "Support" || ["Dedicated Advisor", 'Dedicated Advisor (fixed price packages or bespoke)'].includes(title) || nestingLevel === 1) {
        return (
            <Paper
                elevation={0}
                sx={{
                    margin: "0px !important",
                }}
            >
                <div style={{ padding: '12px 16px', backgroundColor: getBackgroundColor(), }}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 700,
                            textAlign: 'left',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {renderTitle(title, handleModal, mainTitle)}
                    </Typography>
                </div>
                <div style={{ padding: '0 16px 0px' }}>
                    {Object.entries(items).map(([feature, value]) => {
                        if (isPlanRow(value, plans)) {
                            return (
                                <FeatureRow
                                    activeTab={activeTab}
                                    key={feature}
                                    label={feature}
                                    values={value}
                                    plans={plans}
                                    nestingLevel={nestingLevel}
                                    handleModal={handleModal}
                                />
                            );
                        }
                        return null;
                    })}
                </div>
            </Paper>
        );
    }

    return (
        <>
            <Accordion
                defaultExpanded={false}
                sx={{
                    margin: "0px !important",
                    border: 'none !important',
                    boxShadow: 'none !important',
                }}
            >
                <AccordionSummary
                    sx={{
                        backgroundColor: getBackgroundColor(),
                    }}
                    expandIcon={<ExpandMoreIcon sx={{ color: '#4A67FF' }} />}
                >
                    {['Your Investment Journey &', 'FREE Triaging of Applicant Companies &', 'Boost Margins - New Revenue Streams - New Clients', 'We Get You Organised'].includes(title.trim()) ? (
                        <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            sx={{
                                paddingTop: '0px',
                                paddingBottom: '0px',
                                margin: '0px 0px 0px -8px'
                            }}
                        >
                            <Grid
                                xs={activeTab === "Advisors" ? 5 : activeTab === "Investors" ? 6 : 4}
                                sx={{
                                    ...(activeTab === "Advisors" && {
                                        maxWidth: '42% !important',
                                        flexBasis: '42% !important',
                                    })
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        display: 'flex',
                                        alignItems: 'center',
                                        paddingLeft: '8px'
                                    }}
                                >
                                    {renderTitle(title, handleModal, mainTitle)}
                                </Typography>
                            </Grid>
                            {plans.map((plan) => {
                                return (
                                    <Grid
                                        xs={activeTab === "Advisors" ? 2 : activeTab === "Investors" ? 3 : 2} key={plan} sx={{
                                            paddingTop: "0px !important",
                                            ...(activeTab === "Advisors" && {
                                                maxWidth: '19% !important',
                                                flexBasis: '19% !important',
                                            })
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: '13px !important',
                                                fontWeight: '600',
                                                marginLeft: '1rem'
                                            }}
                                            align="center"
                                        >
                                            {PRICING_PLANS[activeTab]?.['subTitle']?.[plan] && <p className='fs11px fw400 mb0rem'>{PRICING_PLANS[activeTab]?.['subTitle'][plan]}</p>}
                                            {plan}
                                        </Typography>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    ) : <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 600,
                            textAlign: 'left',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        {renderTitle(title, handleModal, mainTitle)}
                    </Typography>}
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        px: hasNestedAccordion ? '0' : '0',
                        py: 0
                    }}
                >
                    {Object.entries(items).map(([feature, value]) => {
                        if (isPlanRow(value, plans)) {
                            return (
                                <Box sx={{ ...(nestingLevel === 0 ? { px: '16px' } : ''), py: 0 }} >
                                    <FeatureRow
                                        activeTab={activeTab}
                                        key={feature}
                                        label={feature}
                                        values={value}
                                        nestingLevel={nestingLevel}
                                        plans={plans}
                                    />
                                </Box>
                            );
                        }

                        if (typeof value === 'object' && !Array.isArray(value)) {
                            return (
                                <>
                                    <FeatureAccordion
                                        nested={true}
                                        key={feature}
                                        title={feature}
                                        items={value}
                                        plans={plans}
                                        nestingLevel={nestingLevel + 1}
                                    />
                                </>
                            );
                        }

                        return null;
                    })}
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default FeatureAccordion;
